module.exports = __webpack_public_path__ + "img/tick-read.5c3ef14f.svg";